<template>
    <div class="flex flex-col items-center justify-center h-full showing-main-content">
        <GestaoDeProjetos v-if="projectShowing.value === 0" />
        <ChamadasPublicas v-else-if="projectShowing.value === 1" />
        <CalculadoraDeCarbono v-else-if="projectShowing.value === 2" />
        <SimuladorDeConsumo v-else-if="projectShowing.value === 3" />
        <GestaoDeReunioes v-else />
    </div>
</template>

<script>
import GestaoDeProjetos from "./projects/GestaoDeProjetos.vue"
import ChamadasPublicas from "./projects/ChamadasPublicas.vue"
import CalculadoraDeCarbono from "./projects/CalculadoraDeCarbono.vue"
import GestaoDeReunioes from "./projects/GestaoDeReunioes.vue"
import SimuladorDeConsumo from "./projects/SimuladorDeConsumo.vue"

export default {
    components:{
        GestaoDeProjetos,
        ChamadasPublicas,
        CalculadoraDeCarbono,
        GestaoDeReunioes,
        SimuladorDeConsumo,
    },
    props:{
        projectShowing:{
            type:Object,
            required:true
        }
    },
}
</script>
